import classNames from "classnames";
import React from "react";
import { Field, FieldProps, FieldRenderProps } from "react-final-form";
import "./ToggleFieldV2.scss";

interface IToggleProps<FieldValue, El extends HTMLInputElement>
  extends FieldProps<FieldValue, FieldRenderProps<FieldValue, El>> {
  label?: string;
  labelBefore?: string;
  labelAfter?: string;
}

type Props<El extends HTMLInputElement = HTMLInputElement> = IToggleProps<number, El>;

const ToggleField = <El extends HTMLInputElement = HTMLInputElement>({
  label,
  labelBefore,
  labelAfter,
  ...fieldProps
}: Props<El>) => {
  if (labelBefore && labelAfter) {
    return (
      <Field {...fieldProps} type="checkbox">
        {({ input }) => (
          <label className="two-option">
            <b className={classNames({ active: !input.checked })}>{labelBefore}</b>

            <div
              className={classNames("toggle-field-v2", {
                active: !input.checked,
              })}
              role="switch"
              aria-checked={input.checked}>
              <input id={input.name} type="checkbox" {...input} />
            </div>

            <b className={classNames({ active: input.checked })}>{labelAfter}</b>
          </label>
        )}
      </Field>
    );
  }

  return (
    <Field {...fieldProps} type="checkbox">
      {({ input }) => (
        <div
          className={classNames("toggle-field-v2", {
            active: input.checked,
          })}
          role="switch"
          aria-checked={input.checked}>
          <label htmlFor={input.name}>
            <input id={input.name} type="checkbox" {...input} />
            {label}
          </label>
        </div>
      )}
    </Field>
  );
};

export default ToggleField;
